/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Link from 'next/link';
import { ParsedUrlQueryInput } from 'querystring';
import React, { ReactNode } from 'react';

/** 属性定義 */
type Props = {
  children: ReactNode;
  href: string;
  className?: string;
  target?: string;
  rel?: string;
  query?: ParsedUrlQueryInput;
  onClick?: (e: React.UIEvent<Element, UIEvent>) => void;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtLink = ({ children, href, className, target, rel, query, onClick }: Props) => {
  const isFullPath = href?.match(/^https*:\/\/.+/);

  if (isFullPath) {
    return (
      <a href={href} target={target} rel={rel} className={`atlink ${className}`} onClick={onClick}>
        {children}
      </a>
    );
  }

  if (query) {
    return (
      <Link
        href={{
          pathname: href,
          query,
        }}
        target={target}
        rel={rel}
        className={`atlink ${className}`}
        onClick={onClick}
      >
        {children}
      </Link>
    );
  }

  return (
    <Link href={href} target={target} rel={rel} className={`atlink ${className}`} onClick={onClick}>
      {children}
    </Link>
  );
};
/** 初期値の設定 */
AtLink.defaultProps = {
  className: '',
  target: '_self',
  rel: '',
  onClick: null,
  query: {},
};
export default AtLink;
